import React from 'react';
import Product from './Product';
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import { CookiesProvider } from 'react-cookie';
import { BrowserRouter } from 'react-router-dom';
//import { Helmet } from 'react-helmet';
//import { SITE_NAME } from './const';

export default function MyAppRoot() {
	return (
		<BrowserRouter basename={process.env.PUBLIC_URL}>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				<CookiesProvider>
					<Product />
				</CookiesProvider>
			</ThemeProvider>
		</BrowserRouter>
	);
}
const theme = createTheme({
	typography: {
		overline: {
			fontSize: '0.7rem',
		},
	},
});
/*
const Head = () => (
	<Helmet>
		<title lang='ja'>{SITE_NAME}</title>
		<meta
			name='description'
			content='文章を画像に変換します。背景指定可能。text to image.'
		/>
		<meta name='theme-color' content='rgba(255,255,255,0.98)' />
	</Helmet>
);
*/
